import { isEmpty } from 'lodash';
import getConsentStatusValue from './getConsentStatusValue';
function consentIsPendingOrUnsent(contact) {
  return getConsentStatusValue(contact) === 'pending' || !isEmpty(contact) && isEmpty(contact.consent);
}
export default consentIsPendingOrUnsent;
//# sourceMappingURL=consentIsPendingOrUnsent.js.map